import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  MenuItem,
} from "@mui/material";
import { ReactElement, useState } from "react";

import { IntegrationServiceType } from "~frontend/__generated__/graphql";
import DialogCloseButton from "~frontend/components/DialogCloseButton";
import Select from "~frontend/components/forms/FormSelect";

import { AfterClose } from ".";
import { integrationComponents, integrationLabels } from "./types";

export function AddIntegrationDialog({
  open,
  onClose,
  subaccountId,
}: {
  open: boolean;
  onClose: (oneTimeData?: any) => void;
  subaccountId: string;
}): ReactElement {
  const [integrationType, setIntegrationType] =
    useState<null | IntegrationServiceType>(null);

  const [isPostCreate, setIsPostCreate] = useState(false);

  const IntegrationComponent =
    integrationType && integrationComponents[integrationType];

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle>Add a New Integration</DialogTitle>
      <DialogContent sx={{ minWidth: "400px" }}>
        <DialogCloseButton
          onClose={() => {
            setIsPostCreate(false);
            onClose();
          }}
        />
        <Box>
          <Select
            label="Service Provider"
            value={integrationType || ""}
            onChange={e =>
              setIntegrationType(
                (e.target.value as IntegrationServiceType) || null
              )
            }
            fullWidth
            disabled={isPostCreate}
          >
            {Object.keys(integrationLabels).map(serviceOption => (
              <MenuItem key={serviceOption} value={serviceOption}>
                {integrationLabels[serviceOption as IntegrationServiceType]}
              </MenuItem>
            ))}
          </Select>
          {IntegrationComponent && (
            <IntegrationComponent
              integration={null}
              subaccountId={subaccountId}
              afterCreate={() => setIsPostCreate(true)}
              onClose={(afterClose?: AfterClose) => {
                setIsPostCreate(false);
                onClose(afterClose);
              }}
            />
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
}
